export default "__VITE_ASSET__CHyi735z__"